import { Component, OnDestroy, OnInit } from '@angular/core';
import { UrgentObservationService } from '../services/urgent-observation.service';
import { ObservationModel } from '../../../../observations/models/observation.model';
import { Collection, MultiTenantService } from '@kaiser-software/chassis-core';
import { Subscription } from 'rxjs';

@Component({
    selector: 'eyewatch-recent-observations-widget',
    templateUrl: './urgent-observations.component.html',
    styleUrls: ['./urgent-observations.component.scss']
})
export class UrgentObservationsComponent implements OnInit, OnDestroy {

    public observations: Array<ObservationModel> = [];

    protected subscription = new Subscription();

    constructor(
        protected observationService: UrgentObservationService,
        protected multiTenantManager: MultiTenantService
    ) {
        //
    }

    public ngOnInit(): void {
        this.requestObservations();
    }

    protected requestObservations(): void {
        this.subscription.add(
            this.multiTenantManager.getScope()
                .subscribe(() => {
                    this.observationService
                        .all()
                        .subscribe((observations: Collection) => {
                            this.observations = observations
                                .all()
                                .reverse();
                        });
                })
        );
    }

    public ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

}



// WEBPACK FOOTER //
// ./apps/eyewatch/src/app/eyewatch/dashboards/widgets/urgent-observations/components/urgent-observations.component.ts